// extracted by mini-css-extract-plugin
module.exports = {"modalNotifier":"ModalNotifier_modalNotifier__3FU8Z","modalNotifier__body":"ModalNotifier_modalNotifier__body__3ivVC"};